// src/pages/expense/_shared/expenseDraftConfig.js
// ✅ 전 사업 확산 [1] 공통화 — "지출데이터+기안 통합 작성" 4종 컴포넌트
// (ExpenseDraftNew/List/DetailModal/PreviewWindow)가 사업마다 달라지는 부분을
// 전부 이 config 객체 하나로 받는다. 각 사업 폴더는 이 팩토리로 자기 config를
// 만들고, 4종 컴포넌트에 그대로 넘기는 얇은 래퍼 파일만 갖는다.
//
// namespace는 sessionStorage 키/BroadcastChannel 이름/팝업 창 이름의 접두어로
// 쓰인다 — 사업마다 달라야 두 사업의 미리보기 팝업이 서로의 신호를 듣거나
// sessionStorage를 덮어쓰는 충돌이 안 생긴다.
export function makeExpenseDraftConfig({
  namespace,
  category,
  businessLabel,
  draftNoPrefix,
  dataApiBase,
  combinedCreateApi,
  newRoutePath,
  listRoutePath,
  previewRoutePath,
  templates,
  categoryItemFieldDefaults,
  itemPanelTemplates,
  salaryPanelTemplates,
  // ✅ 전 사업 확산 [5] — item/salary 패널 둘 다 안 쓰는 detail(type:"table") 템플릿을
  // GenericDetailTablePanel(열 구성을 templates.columns에서 그대로 읽는 범용 행 입력)로
  // 보여줄 template_code 목록. 명시적 opt-in 목록으로 둔 이유: 자동 감지(detail이
  // table이면 무조건 패널 표시)로 만들면 이미 배포·검증된 사업들(경영팀의 신용카드/
  // 원천세/채용심사비/퇴직연금 등)이 원래도 detail table 필드를 갖고 있지만 어떤
  // 패널에도 연결 안 된 채(빈 표로 조용히 무시) 이미 검증받은 화면인데, 그 화면들에
  // 새 UI가 갑자기 나타나는 회귀가 생긴다 — 빈 목록 기본값이라 기존 사업은 전혀 영향 없다.
  genericTablePanelTemplates = [],
  fieldNameMap = { categoryName: "category_name", itemName: "item_name", fieldName: "field_name" },
  // ✅ 사업별 템플릿 필드 기본값 덮어쓰기(예: 유류비 차량) — 이 팩토리가 파라미터로
  // 안 받고 반환 객체에도 안 담으면, 각 사업 config 파일이 넘긴 값이 여기서 조용히
  // 버려져 ExpenseDraftNew.jsx의 config.templateFieldOverrides가 항상 빈 객체가
  // 된다(2026-07-31 실측 버그 — 환경/소독·환경/종합 유류비 차량 기본값 미반영 원인).
  templateFieldOverrides = {},
  VendorPanel,
  ExpenseItemPanel,
  SalaryPanel,
  otherCodeLabel = "기타(일반 폼)",
}) {
  return {
    namespace,
    category,
    businessLabel,
    draftNoPrefix,
    dataApiBase,
    combinedCreateApi,
    newRoutePath,
    listRoutePath,
    previewRoutePath,
    templates,
    categoryItemFieldDefaults,
    itemPanelTemplates,
    salaryPanelTemplates,
    genericTablePanelTemplates,
    fieldNameMap,
    templateFieldOverrides,
    VendorPanel,
    ExpenseItemPanel,
    SalaryPanel,
    otherCodeLabel,
    // ✅ 파생값 — 사업마다 자동으로 고유해지도록 namespace로부터 조립.
    previewStorageKey: `${namespace}PreviewData`,
    previewChannelName: `${namespace}-preview`,
    listRefreshChannelName: `${namespace}-list-refresh`,
    previewWindowName: `${namespace.replace(/-/g, "")}Preview`,
  };
}
